import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';
import Delta from 'quill-delta';

import * as graphql from 'generated/graphql';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import QuillEditor from 'packages/kakapo-ui-kit/components/editors/QuillEditor';
import { EvaluationSubmissionDocument } from 'generated/graphql';
import { Button } from '@treams/treams-ui';

export default function EvaluationNoteComposerModal(props: {
	submissionID: string;
	itemID?: string;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [value, setValue] = useState(new Delta());
	const [loading, setLoading] = useState(false);

	const [create] = graphql.useCreateCommentMutation({
		variables: {
			input: {
				targetID: props.submissionID,
				targetType: graphql.CommentTargetType.EvaluationSubmission,
				content: value,
				metadata: props.itemID
					? [
							{
								key: 'formItemID',
								value: props.itemID,
							},
					  ]
					: [],
			},
		},
	});

	const onCreate = async () => {
		if (loading) {
			return;
		}

		setLoading(true);

		create({
			refetchQueries: [EvaluationSubmissionDocument, props.submissionID],
			onCompleted: () => {
				props.onDismiss();
			},
		});
	};

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={props.onDismiss}>
					<ModalHeaderTitle>{t('evaluation.submission.notes.addButton.title')}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<QuillEditor value={value} onChange={setValue} boxedStyling />

					<Flex flexGrow={0} mt={3} justifyContent="flex-end">
						<Button onClick={onCreate} title={t('notes.items.add.buttonTitle')} loading={loading} />
					</Flex>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
